<template>
  <!--visitSource = 2  PC端 -->
  <div v-if="ifLoad" kwName="listPageBoxStyleSet" :style="'text-align: center;'+(styleSetCodeZdy(pageSetInfo.listStyleSet.listPageBoxStyleSet,dataList[0]))" >
    
   
    <!-- 外层表格 -->
    <el-input-number style="width:100px;" v-model="zoomNum" size="mini"  @change="zoomNumChange" :min="10" :max="300" :step="30"></el-input-number>
    <vue-ruler-tool class="table_block_box" :key="'ruler_'+stepLength" :style="('width:'+(maxWidth+50)+'px;height:' + (maxHeight+50) + 'px;')" :is-scale-revise="true"  :stepLength="stepLength"  >
      <el-tooltip class="item" effect="dark" v-if="haveDoorData"  content="出入门位置,拖动可调整" placement="top-start">
       <img class="doorClass" src="./img/door.png"    @mousedown="moveDoor($event)" :style="'left:'+doorx+'px;bottom:'+doory+'px;'"/>
      </el-tooltip>    
      <div class="table_block_box" ref="table_block_box" flag='true' :style="(styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardBoxStyleSet,dataList[0]))+('width:'+maxWidth+'px;height:' + maxHeight + 'px;')" kwName="listPageCardBoxStyleSet">
        <div style="position: absolute;left: -50px;top: 50%;">{{trueHeight}}米</div>
        <template v-for="(dataInfo,dataIndex) in dataList">
          <el-tooltip v-if="dataInfo.NAME"  :key="'dataInfo_'+dataIndex"  class="item" effect="dark" :content="dataInfo.NAME" placement="top">
            <div kwName="listPageCardCommonStyleSet"  class="table_block_one" :style="'background: #DBEEF4;'+('width:'+dataInfo.width+'px;height:'+dataInfo.height+'px;left:'+dataInfo.left+'px;bottom:'+dataInfo.bottom+'px;')+(styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardCommonStyleSet,dataInfo))" @click="listDataClick(dataInfo,dataIndex)">
              <template v-for="(fieldInfo,fieldIndex) in listFieldSet"  >
                <kw_card_field :key="'listField_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"></kw_card_field>
              </template>
            </div>
          </el-tooltip>
          <div v-else :key="'dataInfo_'+dataIndex"  @mousedown="move($event,dataInfo,dataIndex)" kwName="listPageCardCommonStyleSet" class="table_block_one" :style="'background: #DBEEF4;'+('width:'+dataInfo.width+'px;height:'+dataInfo.height+'px;left:'+dataInfo.left+'px;bottom:'+dataInfo.bottom+'px;')+(styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardCommonStyleSet,dataInfo))"  @click="listDataClick(dataInfo,dataIndex)">
            <template v-for="(fieldInfo,fieldIndex) in listFieldSet"  >
              <kw_card_field :key="'listField_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"></kw_card_field>
            </template> 
          </div>
        </template>
        <div style="position: absolute;left: 50%;bottom: -20px;">{{trueWidth}}米</div>
        
      </div>
    </vue-ruler-tool>
    
    
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false">
        <template slot="title"> 
            <div>
                {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
            <el-button @click="dialogIframeZdyCancel">取 消</el-button>
            <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
//card字段组件 kw_card_field
import kw_card_field from '@/components/list/kw_card_field.vue';
// 状态聚合组件 
import kw_having_view from '@/components/look/kw_having_view.vue';
// 人员头像列表组件 
import kw_avatar from '@/components/look/kw_avatar.vue';
// 进度形式
import kw_progress from '@/components/list/kw_progress.vue';
// 倒计时
import kw_count_down from '@/components/form/kw_count_down.vue';
// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';
import kw_icon from '@/components/kw/kw_icon.vue';
// 图片预览组件 kw_preview_image
import kw_preview_image from '@/components/look/kw_preview_image.vue';
// 二维码组件
import vueQr from 'vue-qr'
import VueBarcode from "vue-barcode";
import VueRulerTool from 'vue-ruler-tool'

import pageUtils from '@/js/page/pageUtil.js'; 
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_list_table_block',
  props: {
    pageSetInfo:{
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList:{
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex:{
      type: Number,
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      detailPageInfo:{},
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
          ifLoad:false
      },
      oneIndex:-1,
      maxWidth:600,
      maxHeight:400,
      trueWidth:0,
      trueHeight:0,
      zoomNum:100,
      // presetLineSet:{
      //   width:50,
      //   height:50
      // },
      stepLength:100,
      ifLoad:false,
      doorx:0,
      doory:0,
      haveDoorData:false
     
      
    };
  },
  created() {
    var that = this;
    // var styleSet = pageSetInfo.listStyleSet;
    // if(this.pageSetInfo.listStyleSet.setBlockingCard){
    //     this.cardInfo = this.pageSetInfo.listStyleSet.setBlockingCard
    // }
    // this.updataDataList();
  },
  mounted() {
    
  },
  watch:{
    dataList:function(newVal){
      console.log("dataList-----------------watch");
      this.updataDataList();
    }
  },
  computed:{
  },
  components: {
    kw_card_field,
    kw_having_view,
    kw_avatar,
    kw_progress,
    kw_count_down,
    kw_btn_array,
	  kw_icon,
    kw_preview_image,
    vueQr,
    'barcode': VueBarcode,
    VueRulerTool,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {

     moveDoor(e1){  
          var that = this;     
          let odiv = e1.target;        //获取目标元素
          console.log("----e1--++",e1);
          console.log("----odiv--++",odiv);
          let objheight = odiv.clientHeight;
          let objwidth = odiv.clientWidth;
          let parentWidth = that.maxWidth+50;
          let parentHeight = that.maxHeight+50;
          
          //算出鼠标相对元素的位置
          let disX = e1.clientX - odiv.offsetLeft;
          let disY = e1.clientY - odiv.offsetTop;
          let x,y;
          document.onmousemove = (e1)=>{       //鼠标按下并移动的事件
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e1.clientX - disX;    
              let top = e1.clientY - disY;
              console.log("---x--y-",left,top);
              left = left<0?0:left;
              top = top<0?0:top;
              left = (left+objwidth) > parentWidth?(parentWidth-objwidth):left;
              top = (top+objheight) >parentHeight?(parentHeight-objheight):top;
              let bottom = parentHeight-objheight-top;
              // left = (left < (parentWidth/2))?0:(parentWidth-objwidth);
              // top = (top < (parentHeight/2))?0:(parentHeight-objheight);
              // bottom = (top == 0? (parentHeight-objheight):0);


               x =(left/ parentWidth)*that.dataList[0].MAX_LENGTH;
               y =(bottom/ parentHeight)*that.dataList[0].MAX_WIDTH;
              console.log("---x--y-",x,y,"=====left==top==bottom===",left,top,bottom);
              //移动当前元素
              odiv.style.left = left + 'px';
              odiv.style.bottom = bottom + 'px';
          };
          document.ondragstart = function(e1) {
            e1.preventDefault();
          };
          document.ondragend = function(e1) {
              e1.preventDefault();
          };
          document.onmouseup = (e1) => {
             document.onmousemove = null;
            document.onmouseup = null;
            console.log("----进入 e1.....");
            var kw_look = null;
            that.getParentKwLook(val => {
                kw_look = val;
            });

            that.$confirm("是否调整库房进入口位置？", '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',                                 
              type: 'warning'
            }).then(() => {
                //修改门位置
              let dataInfos = kw_look.dataInfo;
              dataInfos.zdyOtherParam={"siteX":x ,"siteY":y};          
              pageUtils.dataButtonClick(kw_look,kw_look.pageSetInfo.operaButtonSet[1],dataInfos);  
            }).catch(() => {
                //移动回以前位置
              odiv.style.left = that.doorx + 'px';
              odiv.style.bottom = that.doory + 'px';        
            });
          
            
          };
      },    
   
   //移动事件
    move(e,dataInfo,index){
      var that = this;
      //得到页面操作按钮个数,大于2个操作按钮为可移动位置页面，移动位置的修改页面为第2个按钮
      let operaNum = that.pageSetInfo.operaButtonSet.length;
      console.log("------div.table_block_one---",e.target._prevClass);
      //查看页面按钮中是否包含修改按钮
      var operaButtonSet = that.pageSetInfo.operaButtonSet;
      let ifUpdateBtn = false;
      let updateIndex = 0;
      operaButtonSet.forEach((buttonItem, index) => {
          if(buttonItem.buttonType == 12){
              ifUpdateBtn= true;
              updateIndex = index;
              return;
          };
      });
      
      if(operaNum >=2 && ifUpdateBtn){        
        let firstTime='',lastTime='';
         //得到移动开始时间
        firstTime = new Date().getTime();
        console.log("----e----",e);

        var objclass = e.target._prevClass;
        //点击到的拖动对象为div table_block_one 时，才进行拖动
        if(objclass == 'table_block_one'){
          let odiv = e.target;        //获取目标元素      
          //算出鼠标相对元素的位置
          // console.log("-----dataInfo.width,dataInfo.height---",dataInfo.width,dataInfo.height);
          // console.log("----e.clientX---odiv.offsetLeft",e.clientX,odiv.offsetLeft);
          // console.log("==maxWidth,maxHeight,trueWidth,trueHeight=====",that.maxWidth,that.maxHeight,that.trueWidth,that.trueHeight);
          //鼠标点击的位置 到对象的距离；
          let disX = e.clientX - odiv.offsetLeft;
          let disY = e.clientY - odiv.offsetTop;
          //移动对象的宽高
          let objWidth = dataInfo.width;
          let objheight =dataInfo.height;
    
          //移动前对象的左边距离与底边距
          let objleft = dataInfo.left;
          let objbottom =dataInfo.bottom;
          //x 向左距离多少像素， y 向底部距离多少像素
          let x = objleft;
          let y = objbottom;
          document.onmousemove = (e)=>{       //鼠标按下并移动的事件
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e.clientX - disX;    
              let top = e.clientY - disY;            
              
              //绑定元素位置到positionX和positionY上面
              this.positionX = top;
              this.positionY = left;
              let bottom = that.maxHeight-top-objheight;
              //判断不可超出边界
              if(bottom<=0){
                bottom = 0;
              }
              if(bottom > (that.maxHeight-objheight) ){
                bottom = that.maxHeight-objheight;
              }
              if(left < 0){
                left = 0;
              }
              if(left > (that.maxWidth-objWidth)){
                left = that.maxWidth-objWidth;
              }
    
               x =(left/ that.maxWidth)*this.dataList[index].MAX_LENGTH;
               y =(bottom/ that.maxHeight)*this.dataList[index].MAX_WIDTH;
             // console.log("----x,y====",x,y);
              //移动当前元素
              odiv.style.left = left + 'px';
              odiv.style.bottom = bottom + 'px';
          };
          document.onmouseup = (e) => {
            console.log("----进入 e.....");
            document.onmousemove = null;
            document.onmouseup = null;
            lastTime = new Date().getTime(); 
            firstTime = (firstTime==''?lastTime:firstTime)
            //如果移动开始时间为空，则判断为点击事件
            console.log("----firstTime--",firstTime,"---lastTime--",lastTime,"====结果====",(lastTime-firstTime));
            if((lastTime-firstTime) < 110 ){         
               that.$refs.table_block_box.setAttribute('flag', true);
            }else{
              that.$refs.table_block_box.setAttribute('flag', false);
    
              if(objleft != x || objbottom != y ){
                that.$confirm("是否想调整位置到此处？", '提示', {
                  confirmButtonText: '调整',
                  cancelButtonText: '不调整',  
                  // distinguishCancelAndClose: true,             
                  type: 'warning'
                }).then((aaa) => {                
                  dataInfo.zdyOtherParam={"siteX":x,"siteY":y}; 
                  pageUtils.dataButtonClick(that,that.pageSetInfo.operaButtonSet[updateIndex],dataInfo);   
                }).catch((action) => {               
                    //移动当前元素
                    odiv.style.left = objleft + 'px';
                    odiv.style.bottom = objbottom + 'px';           
                });
              }  
            }             
          };
        }
      }
    },  
   
    styleSetCodeZdy(json,rowData) {
      if(json && rowData) {
        var styleSetCode = json.styleSetCode;
        
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        console.log("json.zdyJs===================",json.zdyJs,styleSetCode);
        return styleSetCode;
      } else {
        return "";
      }
    },
    /**
     * 进行数据的结构处理
     */
    updataDataList(){
      var that = this;
      var dataList = this.dataList;
      if (this.dataList) {
        var widthBasic = window.innerWidth*0.9-50;
        var heightBasic = window.innerHeight-70;
        if(this.dataList[0].DOORX>=0){
          this.haveDoorData = true;
        };
        var truedoorx = this.dataList[0].DOORX;
        var truedoory = this.dataList[0].DOORY;
        var trueMaxWidth = this.dataList[0].MAX_LENGTH;
        var trueMaxHeight = this.dataList[0].MAX_WIDTH;
        that.trueWidth = trueMaxWidth;
        that.trueHeight = trueMaxHeight;
        
        var zoomNum = that.zoomNum;
        console.log("heightBasic===widthBasic=====window.innerHeight====window.innerWidth======",heightBasic,widthBasic,window.innerHeight,window.innerWidth);
        var maxHeight = widthBasic*(trueMaxHeight/trueMaxWidth);
        if(maxHeight > heightBasic) {

          maxHeight = heightBasic;
          widthBasic = maxHeight/(trueMaxHeight/trueMaxWidth);
        }
        
        
        var maxWidth = widthBasic*(zoomNum/100);
        var maxHeight = maxHeight*(zoomNum/100);
        // that.presetLineSet.height = trueMaxHeight/(that.maxHeight/50);
        // that.presetLineSet.width = trueMaxWidth/(that.maxWidth/50);
        that.stepLength = Math.ceil((trueMaxWidth*100)/(maxWidth/50)/10)*10;
        console.log("heightBasic========22==========",trueMaxWidth,maxWidth,that.stepLength);
        maxWidth = ((trueMaxWidth*100)/that.stepLength)*50;
        maxHeight = ((trueMaxHeight*100)/that.stepLength)*50;
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this.doorx = (this.maxWidth+50)*(truedoorx/trueMaxWidth);
        this.doory = (this.maxHeight+50)*(truedoory/trueMaxHeight);
        dataList.forEach((dataInfo,dataIndex) => {
          this.listFieldSet.forEach((fieldInfo)=>{
            if(fieldInfo.styleSet != null && (fieldInfo.styleSet.cssStyle == 12 || fieldInfo.styleSet.cssStyle == 14)) {
              if (dataInfo[fieldInfo.fieldAliasName]) {
                var arr = dataInfo[fieldInfo.fieldAliasName].split(",");
                dataInfo[fieldInfo.fieldAliasName] = arr;
              }
            }
            dataInfo.width = (this.maxWidth*(dataInfo.LENGTH/trueMaxWidth))
            dataInfo.height = (this.maxHeight*(dataInfo.WIDTH/trueMaxHeight));
            dataInfo.left = this.maxWidth*(dataInfo.X/trueMaxWidth);
            dataInfo.bottom = this.maxHeight*(dataInfo.Y/trueMaxHeight);
          })
        })
        console.log("dataList===============",dataList);
        that.ifLoad = true;
      }
      this.$forceUpdate();
    },
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo,dataIndex){
      var that = this;
      //判断是点击事件还是拖拽事件
       let isClick = this.$refs.table_block_box.getAttribute('flag')
       console.log("--isClick----",isClick);      
      console.log("-----that.pageSetInfo.operaButtonSet----",that.pageSetInfo.operaButtonSet);
      if(isClick ==='true'){
        //判断列表是否包含删除按钮，如果包含则用户选择点击是想查看详情还是删除
        var operaButtonSet = that.pageSetInfo.operaButtonSet;
        let ifDelBtn = false;
        let delIndex = 0;
        operaButtonSet.forEach((buttonItem, index) => {
            if(buttonItem.buttonType == 13){
                ifDelBtn= true;
                delIndex = index;
                return;
            };
        });
        console.log("click===============");
        if(ifDelBtn){
          this.$confirm("您想查看详情还是删除？", '提示', {
            confirmButtonText: '查看详情',
            cancelButtonText: '删除',
            distinguishCancelAndClose: true,               
            type: 'warning'
          }).then(() => {
            this.oneIndex = dataIndex;
            pageUtils.listDataClick(this, dataInfo);
          }).catch((action) => {
             if(action == "cancel") {
                pageUtils.dataButtonClick(that,that.pageSetInfo.operaButtonSet[delIndex],dataInfo);  
             }       
          });

        }else{
          this.oneIndex = dataIndex;
          pageUtils.listDataClick(this, dataInfo);
        }
      }
      else{
        return false;
      } 
     
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo,dataIndex) {
      this.oneIndex = dataIndex;
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 调用列表数据刷新方法
     */
    initLoadDataInfo:function(){
//      this.triggerEvent("refreshevent");
        this.$emit("refreshevent");
    },
    /**
     * 返回前一页
     */
    goBack(){
      this.$emit("goBack");
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
          this.refreshevent();
      }
    },
    refreshevent:function(){
      this.$emit("refreshevent");
    },

    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback) {
      console.log("kw_card_default========getParentKwLook========");
      if(this.$listeners['getParentKwLook']){
        var parentKwLook;
        this.$emit("getParentKwLook",val => {
            parentKwLook = val
        });
        callback(parentKwLook);
      } else {
        callback(null);
      }
    },
    getParentKwList(callback) {
      callback(this);
    },
    /**
     * 打开文件预览组件
     */
    toPreviewFile:function(dataInfo,fieldone) {
        console.log("fieldone======================",fieldone);
        var that = this;
        var file = {};
        file.name = dataInfo[fieldone.fieldAliasName+"_NAME"];
        file.downAddress = dataInfo[fieldone.fieldAliasName+"_DOWNADDRESS"];
        pageUtils.toPreviewFile(that,file,fieldone);
        // window.open(url);
    },
    /**
     * 缩放点击时
     */
    zoomNumChange:function(){
      this.updataDataList();
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table_block_box{
  border:2px solid rgb(34, 34, 34);margin: 0px auto 30px auto;position: relative;
}
.table_block_one{
  border:2px solid rgb(34, 34, 34);;position: absolute;
}

.doorClass{
        position: absolute;     /*定位*/         
        width: 45px;
        height: 45px;  
        z-index: 1000;     
    }
</style>